"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
/**
 * We are wrapping the axios client, so that dependency on the library is in a
 * single place.
 * This way we can control the axios Config from a single place.
 */
class HttpClient {
    /**
     * @param {} instance
     */
    constructor(instance) {
        this.instance = instance || axios_1.default.create();
        this.instance.defaults.headers.post['Content-Type'] = 'application/json';
    }
    /**
     * Post request
     * @param {string} url
     * @param data
     * @param config
     * @returns {AxiosPromise<any>}
     */
    post(url, data, config) {
        return this.instance.post(url, data, config);
    }
    /**
     * Get request
     * @param {string} url
     * @param config
     * @returns {AxiosPromise<any>}
     */
    get(url, config) {
        return this.instance.get(url, config);
    }
    /**
     * Put request
     * @param {string} url
     * @param data
     * @param config
     * @returns {AxiosPromise<any>}
     */
    put(url, data, config) {
        return this.instance.put(url, data, config);
    }
    /**
     * Patch request
     * @param {string} url
     * @param data
     * @param config
     * @returns {AxiosPromise<any>}
     */
    patch(url, data, config) {
        return this.instance.patch(url, data, config);
    }
}
exports.HttpClient = HttpClient;
